import { connect } from "react-redux";
import { useState, useEffect } from "react";
import {camelCase, merge} from "lodash";

import Select from "react-select";
import ReactFileReader from "react-file-reader";
import NotificationManager from "react-notifications/lib/NotificationManager";

import { Actions as ACCOUNTINGACTIONS } from "../../../store/actions/accountingActions";
import { Actions as ACCOUNTING_INTEGRATION_ACTIONS } from "../../../components/integrations/accountingIntegrations/store/accountingIntegrationActions";

import {CheckCircleIcon, DocumentArrowUpIcon, ExclamationCircleIcon, PlusCircleIcon} from "@heroicons/react/20/solid";

const typeOptions = [
	{ label: "Expense", value: "Expense" },
	{ label: "Liability", value: "Liability" },
];

const Ledgers = ({
	data,
	setData,
	handleFiles,
	ledgersList,
	processingFile,
	clearFiles,
	save,
	dirty,
	connected,
	logo,
	integration,
	integrationName,
	importAccountingCategoriesAndCostCenters
}) => {
	const [dataLoaded, setDataLoaded] = useState(false);

	const addLedger = () => {
		const newData = [...data];
		newData.push({});
		setData(newData);
	};

	const submit = () => {
		let seen = [];

		//Prevent empty submit
		if (!data.length) {
			NotificationManager.error("There are no Ledgers to submit!", "Ledgers");
			return;
		}

		//Checks for duplicate and empty codes in form
		for (const code in data) {
			const num = data[code].Code;

			if (!num) {
				NotificationManager.error("Code fields cannot be empty!", "Ledgers");
				return;
			}

			if (seen.includes(num)) {
				NotificationManager.error(`Duplicate codes found: ${num}`, "Ledgers");
				return;
			}

			seen.push(num);
		}

		NotificationManager.success("Submitted successfully", "Ledgers");
		save();
		clearFiles();
	};

	useEffect(() => {
		if (ledgersList.length == 0 || processingFile) return;

		const newData = [...data];

		for (const ledger in ledgersList) {
			let replaced = false;
			for (const i in newData) {
				if (newData[i].Code == ledgersList[ledger].Code) {
					newData.splice(i, 1, ledgersList[ledger]);
					replaced = true;
				}
			}

			if (replaced) continue;
			newData.push(ledgersList[ledger]);
		}

		setData(newData);
	}, [processingFile]);

	useEffect(() => {
		if (dataLoaded) return;
		setDataLoaded(true);
	}, [data]);

	return (
		<>
			<form className="form-grid col-12">
				<div className="form-section col-span-3 row-span-2">
					<div className="col-xs-7 pull-left form-container">
						<h4>Ledgers</h4>
					</div>

					{!connected && (
						<div className="col-xs-2 pull-right">
							<ReactFileReader
								fileTypes={[".csv", ".dbf", ".*", "application/dbase", "application/dbf"]}
								handleFiles={handleFiles}
							>
								{data.length == 0 ? (
									<div
										className="btn btn-success pull-right"
										type="button"
									>
										<DocumentArrowUpIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Import</div>
									</div>
								) : (
									<div
										className="btn btn-default pull-right"
										type="button"
									>
										<DocumentArrowUpIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
										<div style={{ float: "left" }}>Import</div>
									</div>
								)}
							</ReactFileReader>
						</div>
					)}
					{connected && (
						<div className="col-xs-4 pull-right text-right">
							Connected with
							<img src={logo} style={{ height: "2em", verticalAlign: "text-bottom" }} />
						</div>
					)}
					<div className="col-xs-12 form-container form-material">
						<table className="table table-borderless">
							<thead style={{ background: "#ea611c", color: "#fff" }}>
								<tr>
									<th scope="col">Code</th>
									<th scope="col">Name</th>
									<th scope="col">Type</th>
								</tr>
							</thead>
							<tbody style={{ background: "#fff" }}>
								{data?.map((ledger, index) => {
									const updateField = (field, value) => {
										if (!field) return;
										const objectAtIndex = data[index];
										const newData = merge(objectAtIndex, {
											...(typeof field == "object" ? field : { [field]: value }),
										});
										const newArray = [...data];
										newArray[index] = newData;
										setData(newArray);
									};
									return (
										<LedgerRow
											data={ledger}
											updateField={updateField}
											connected={connected}
										/>
									);
								})}
							</tbody>
						</table>
					</div>
					{
						connected ?
						<div className="col-xs-12 pull-right mb-10">
							<p>
								You are connected to {integrationName}. If you need to make changes to your ledgers, please do so in {integrationName}.
							</p>
							<button
								type="button"
								className="btn btn-success pull-right"
								onClick={() => importAccountingCategoriesAndCostCenters(integration)}
							>
								{/*<RefreshIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />*/}
								<span style={{ float: "left" }}>Import & Sync Accounting Categories from {integrationName}</span>
							</button>
						</div> : (
						<div>
							<div
								className="col-xs-12 pull-right"
								style={{ marginBottom: 10 }}
							>
								<button
									type="button"
									className="btn btn-success pull-right"
									onClick={() => addLedger()}
								>
									<PlusCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									<span style={{ float: "left" }}>Add</span>
								</button>
							</div>
							<div
								className="col-xs-2 pull-right"
								style={{ marginBottom: 10 }}
							>
								<button
									type="button"
									className="btn btn-success pull-right"
									onClick={() => submit()}
								>
									{
										dirty ?
											<ExclamationCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
											:
											<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
									}
									<span style={{ float: "left" }}>
										{
											dirty ?
												"Save Changes"
												:
												"Saved"
										}
									</span>
								</button>
							</div>
						</div>
						)
					}
				</div>
			</form>
		</>
	);
};

const LedgerRow = ({ data, updateField, connected }) => {
	return (
		<tr>
			<td className="form-material form-container col-xs-3">
				{
					connected ?
						data?.code
						:
						<input
							id="code"
							name="code"
							className="form-control form-input"
							autoComplete="off"
							value={data?.code}
							onChange={(e) => {
								updateField("code", e.target.value || null);
							}}
						/>
				}
			</td>
			<td className="form-material form-container col-xs-3">
				{
					connected ?
						data?.name
						:
						<input
							id="name"
							name="name"
							className="form-control form-input"
							autoComplete="off"
							value={data?.name}
							onChange={(e) => {
								updateField("name", e.target.value || null);
							}}
						/>
				}
			</td>
			<td className="col-xs-2">
				{
					connected ?
						data?.type
						:
						<Select
							name="expense"
							options={typeOptions}
							placeholder="Choose one"
							value={typeOptions.find((i) => i.value == data?.type)}
							onChange={(e) => {
								updateField("type", e?.value || null);
							}}
						/>
				}
			</td>
		</tr>
	);
};

const mapStateToProps = (state) => {

	// object with accounting integrations (names as keys)
	const accountingIntegrations = state?.integration?.accounting
	const accountingIntegrationConnected = accountingIntegrations && Object.keys(accountingIntegrations).find(key => accountingIntegrations[key]?.connected)

	return {
		processingFile: state?.accounting?.fileImport?.processingFile,
		ledgersList: state?.accounting?.fileImport?.data || [],
		data: state?.accounting?.ledgers?.data || [],
		dirty: state?.accounting?.ledgers?.dirty ?? false,
		connected: accountingIntegrationConnected?.length > 0,
		integration: accountingIntegrationConnected,
		integrationName: accountingIntegrationConnected ? state?.integrationDetails?.accounting?.[camelCase(accountingIntegrationConnected)]?.name : null,
		logo: accountingIntegrationConnected ?  state?.integrationDetails?.accounting?.[camelCase(accountingIntegrationConnected)]?.logo : null

	};
};

const mapDispatchToProps = (dispatch) => ({
	importAccountingCategoriesAndCostCenters: (integration) => dispatch(ACCOUNTING_INTEGRATION_ACTIONS.importAccountingCategoriesAndCostCenters(integration)),
	handleFiles: (files) => dispatch(ACCOUNTINGACTIONS.handleAccountingFiles(files)),
	clearFiles: () => dispatch(ACCOUNTINGACTIONS.accountingClearFile()),
	save: () => dispatch(ACCOUNTINGACTIONS.accountingSaveLedgers()),
	setData: (data) => dispatch(ACCOUNTINGACTIONS.updateLedgers(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Ledgers);
